const getters = state => ({});

export default getters;